// app/assets/javascripts/convert_to_opv_modal.js - VERSÃO CORRIGIDA V2
import axios from "axios";
import {
  enableSelect,
  disableSelect,
} from "./attendance_concerns";

const ConvertToOpvModal = (() => {
  const BASE_URL = "searches";
  let currentLead = null;
  let leadMoves = [];
  let isConverting = false;

  // Seletores
  const sel = {
    modal: "#convertToOpvModal",
    dealerSelect: "#opvDealerId",
    sellerSelect: "#opvSellerId",
    noteTextarea: "#opvNote",
    submitBtn: "#submitConvertToOpv",
    cancelBtn: "#cancelConvertToOpv",
  };

  // Helper para obter elemento com segurança
  const getElement = (selector) => {
    const el = document.querySelector(selector);
    if (!el) console.warn(`Elemento não encontrado: ${selector}`);
    return el;
  };

  const init = () => {
    const modal = getElement(sel.modal);
    if (!modal) {
      console.warn("Modal de conversão não encontrado no DOM");
      return;
    }

    setupEventListeners();
  };

  const setupEventListeners = () => {
    // Abrir modal ao clicar em botões com data-convert-lead
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-convert-lead]");
      if (btn) {
        const leadId = btn.dataset.convertLead;
        openModal(parseInt(leadId));
        e.preventDefault();
      }
    });

    // Mudança de dealer carrega sellers
    const dealerSelect = getElement(sel.dealerSelect);
    if (dealerSelect) {
      dealerSelect.addEventListener("change", (e) => {
        handleDealerChange(e.target.value);
        updateSubmitButtonState();
      });
    }

    // Mudança de seller habilita botão
    const sellerSelect = getElement(sel.sellerSelect);
    if (sellerSelect) {
      sellerSelect.addEventListener("change", (e) => {
        updateSubmitButtonState();
      });
    }

    // Cancelar modal
    const cancelBtn = getElement(sel.cancelBtn);
    if (cancelBtn) {
      cancelBtn.addEventListener("click", closeModal);
    }

    // ADICIONE ISTO - Botão X de fechar:
    const closeBtn = document.querySelector(`${sel.modal} .close`);
    if (closeBtn) {
      closeBtn.addEventListener("click", closeModal);
    }

    // Submeter formulário
    const submitBtn = getElement(sel.submitBtn);
    if (submitBtn) {
      submitBtn.addEventListener("click", submitForm);
    }

    // Fechar ao clicar no backdrop
    const modal = getElement(sel.modal);
    if (modal) {
      modal.addEventListener("click", (e) => {
        if (e.target === modal) {
          closeModal();
        }
      });
    }
  };

  const populateLeadMovements = () => {
    const movementsEl = document.getElementById('leadMovements');
    if (!movementsEl || !leadMoves || leadMoves.length === 0) {
      if (movementsEl) {
        movementsEl.innerHTML = '<small class="text-muted">Nenhuma movimentação</small>';
      }
      return;
    }

    // Limitar a 5 últimas movimentações
    const movements = leadMoves.slice(0, 5);

    const html = movements.map(move => {
      const user = move.user ? `${move.user} - ` : '- ';
      const nextContact = move.next_contact ? `<br><small><em>Próximo contato: ${move.next_contact}</em></small>` : '';

      return `
      <div class="mb-3 pb-2 border-bottom">
        <small class="text-muted d-block">
          <strong>${move.created_at}</strong>
          <br>
          <em>${move.elapsed_time}</em>
        </small>
        <div class="mt-2">
          <strong>${user}${move.status}</strong>
          ${move.text ? `<br><small>${move.text}</small>` : ''}
          ${nextContact}
        </div>
      </div>
    `;
    }).join('');

    movementsEl.innerHTML = html;
  };

  const openModal = async (leadId) => {
    try {
      const dealerSelect = getElement(sel.dealerSelect);
      if (!dealerSelect) return;

      showLoading(dealerSelect, "Carregando revendas...");

      // Buscar dados do lead
      const leadResponse = await axios.get(`leads/${leadId}`);
      currentLead = leadResponse.data.lead;
      leadMoves = leadResponse.data.moves || [];

      if (!currentLead) {
        throw new Error("Lead não encontrado");
      }

      // Resetar formulário
      resetForm();

      // Carregar dealers baseado no group_id
      const dealersResponse = await axios.get(
        `${BASE_URL}/dealers?q[group_id_eq]=${currentLead.group_id}`
      );

      const dealers = dealersResponse.data.dealers || [];

      if (dealers.length > 0) {
        populateDealerSelect(dealers);
        showModal();

        // Preencher informações do lead
        document.getElementById('leadName').textContent = currentLead.name || '-';
        document.getElementById('leadPhone').textContent = currentLead.phone_number || '-';
        document.getElementById('leadEmail').textContent = currentLead.email || '-';

        populateLeadMovements();
      } else {
        throw new Error("Nenhuma revenda encontrada para este lead");
      }
    } catch (error) {
      console.error("Erro ao abrir modal:", error);
      showError(`Erro ao carregar dados: ${error.message}`);
    }
  };

  const closeModal = () => {
    const modal = getElement(sel.modal);
    if (!modal) return;

    // Tentar Bootstrap 5+ primeiro
    try {
      if (window.bootstrap?.Modal) {
        const instance = bootstrap.Modal.getInstance(modal);
        if (instance) {
          instance.hide();
          return;
        }
      }
    } catch (e) {
      // Falhou com Bootstrap 5, tentar jQuery
    }

    // Bootstrap 4 com jQuery
    try {
      if (window.$ && typeof window.$.fn.modal === "function") {
        $(modal).modal("hide");
        return;
      }
    } catch (e) {
      // Falhou com jQuery
    }

    // Fallback: remover classe show
    try {
      modal.classList.remove("show");
      modal.style.display = "none";
    } catch (e) {
      console.error("Erro ao fechar modal:", e);
    }
  };

  const showModal = () => {
    const modal = getElement(sel.modal);
    if (!modal) return;

    // Bootstrap 5+
    if (window.bootstrap?.Modal) {
      const instance = new window.bootstrap.Modal(modal);
      instance.show();
    }
    // Bootstrap 4 com jQuery
    else if (window.$ && typeof window.$.fn.modal === "function") {
      $(modal).modal("show");
    }
    // Fallback: mostrar com CSS
    else {
      modal.classList.add("show");
      modal.style.display = "block";
    }
  };

  const resetForm = () => {
    const dealerSelect = getElement(sel.dealerSelect);
    const sellerSelect = getElement(sel.sellerSelect);
    const noteTextarea = getElement(sel.noteTextarea);

    if (dealerSelect) {
      dealerSelect.value = "";
      dealerSelect.disabled = false;
    }

    if (sellerSelect) {
      sellerSelect.value = "";
      sellerSelect.innerHTML = '<option value="">Selecione primeiro a Revenda</option>';
      sellerSelect.disabled = true;
    }

    if (noteTextarea) {
      noteTextarea.value = "";
    }

    updateSubmitButtonState();
  };

  const populateDealerSelect = (dealers) => {
    const select = getElement(sel.dealerSelect);
    if (!select) return;

    const options = ['<option value="">Selecione a Revenda</option>'];

    dealers.forEach(dealer => {
      options.push(`<option value="${dealer.id}">${dealer.name}</option>`);
    });

    select.innerHTML = options.join('');
    enableSelect(select);
    refreshSelectPicker(select);
  };

  const handleDealerChange = async (dealerId) => {
    const sellerSelect = getElement(sel.sellerSelect);
    if (!sellerSelect) return;

    if (!dealerId) {
      sellerSelect.innerHTML =
        '<option value="">Selecione primeiro a Revenda</option>';
      sellerSelect.disabled = true;
      updateSubmitButtonState();
      return;
    }

    try {
      showLoading(sellerSelect, "Carregando vendedores...");

      const sellersResponse = await axios.get(
        `${BASE_URL}/sellers?q[dealer_id_eq]=${dealerId}&q[block_eq]=false`
      );

      const sellers = sellersResponse.data.sellers || [];

      if (sellers.length > 0) {
        populateSellerSelect(sellers);
      } else {
        sellerSelect.innerHTML =
          '<option value="">Nenhum vendedor encontrado</option>';
        sellerSelect.disabled = true;
      }
    } catch (error) {
      console.error("Erro ao buscar vendedores:", error);
      sellerSelect.innerHTML =
        '<option value="">Erro ao carregar vendedores</option>';
      sellerSelect.disabled = true;
    }

    updateSubmitButtonState();
  };

  const populateSellerSelect = (sellers) => {
    const select = getElement(sel.sellerSelect);
    if (!select) return;

    const options = ['<option value="">Selecione o Vendedor</option>'];

    sellers.forEach(seller => {
      options.push(`<option value="${seller.id}">${seller.name}</option>`);
    });

    select.innerHTML = options.join('');
    enableSelect(select);
    refreshSelectPicker(select);
  };

  const updateSubmitButtonState = () => {
    const dealerId = getElement(sel.dealerSelect)?.value;
    const sellerId = getElement(sel.sellerSelect)?.value;
    const submitBtn = getElement(sel.submitBtn);

    if (!submitBtn) return;

    const isValid = dealerId && sellerId;
    submitBtn.disabled = !isValid;

    if (isValid) {
      submitBtn.textContent = "✓ Converter para OPV";
      submitBtn.className = "btn btn-success";
    } else {
      submitBtn.textContent = "Converter para OPV";  // ← Mudei aqui
      submitBtn.className = "btn btn-light";
    }
  };

  const showLoading = (selectElement, message) => {
    if (!selectElement) return;
    selectElement.innerHTML = `<option value="">${message}</option>`;
    selectElement.disabled = true;
  };

  const refreshSelectPicker = (selectEl) => {
    if (!selectEl) return;

    try {
      // Primeiro, tentar jQuery directamente
      if (window.$ && $(selectEl).data('selectpicker')) {
        $(selectEl).selectpicker('refresh');
        return;
      }
    } catch (error) {
      console.warn('Erro ao atualizar selectpicker com jQuery:', error);
    }

    try {
      // Usa a forma específica de acessar o selectpicker
      let [refEl] = Object.values(selectEl).filter(a => a?.liveSearch && a);
      if (refEl && refEl.selectpicker) {
        // Usa setTimeout para evitar conflitos de renderização
        setTimeout(() => {
          refEl.selectpicker.refresh();
        }, 0);
      }
    } catch (error) {
      console.warn('Erro ao atualizar selectpicker:', error);
    }
  };

  const submitForm = async () => {
    if (isConverting) return;

    const dealerId = getElement(sel.dealerSelect)?.value;
    const sellerId = getElement(sel.sellerSelect)?.value;
    const note = getElement(sel.noteTextarea)?.value || "";

    if (!dealerId || !sellerId) {
      showError("Preencha todos os campos obrigatórios");
      return;
    }

    if (!currentLead) {
      showError("Erro: Lead não foi carregado");
      return;
    }

    isConverting = true;
    const submitBtn = getElement(sel.submitBtn);
    const originalText = submitBtn.textContent;

    submitBtn.disabled = true;
    submitBtn.innerHTML =
      '<span class="spinner-border spinner-border-sm mr-2"></span>Convertendo...';

    try {
      // Preparar dados do attendance
      const attendanceData = prepareAttendanceData(
        parseInt(dealerId),
        parseInt(sellerId),
        note
      );

      // 1. Criar o attendance
      const attendanceResponse = await axios.post("attendances", {
        attendance: attendanceData,
        lead_id: currentLead.id,
      });

      if (attendanceResponse.status === 201) {
        const attendanceId = attendanceResponse.data.id;

        // 2. Replicar agendamento do lead para o attendance
        try {
          // Buscar o move do lead com as informações de agendamento
          const leadMove = leadMoves?.find(m => m.status === "Visita Agendada");

          if (leadMove && leadMove.next_contact) {
            // Converter data de DD/MM/YYYY para YYYY-MM-DD
            const [day, month, year] = leadMove.next_contact.split('/');
            const nextContactISO = `${year}-${month}-${day}`;

            // Criar move no attendance com status_id sempre 91
            await axios.post(`attendances/${attendanceId}/create_move`, {
              move: {
                moveable_type: "Attendance",
                status_id: 91,
                category_id: null,
                kind: "activity",
                text: leadMove.text || note,
                next_contact: nextContactISO,
              }
            });
          }
        } catch (moveError) {
          console.warn('Agendamento não foi replicado:', moveError);
          // Continua mesmo se não conseguir replicar
        }

        // 3. Converter lead para status 7 (OPV)
        await axios.post(`leads/${currentLead.id}/send_to_status/7`);

        // Sucesso
        showSuccess("Lead convertido para OPV com sucesso!");
        closeModal();

        // Recarregar página após 1.5 segundos
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    } catch (error) {
      console.error("Erro ao converter:", error);

      const errorMsg =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Erro desconhecido ao converter";

      showError(`Erro: ${errorMsg}`);

      submitBtn.disabled = false;
      submitBtn.textContent = originalText;
      isConverting = false;
    }
  };

  const prepareAttendanceData = (dealerId, sellerId, note) => {
    return {
      lead_id: currentLead.id,
      company_id: currentLead.company_id,
      dealer_id: dealerId,
      seller_id: sellerId,
      color_id: currentLead.vehicle?.color_id,
      model_id: currentLead.model_id,
      trim_id: currentLead.vehicle?.trim_id,
      heat_level: currentLead.heat_level,
      kind: currentLead.kind,
      email: currentLead.email,
      name: currentLead.name,
      phone_number: currentLead.phone_number,
      profession: currentLead.profession,
      origin_id: currentLead.origin_id,
      status_id: 10,
      fresh: true,
      recurrence: false,
      test_drive: "",
      test_drive_confirmation: false,
      kind_status: currentLead.condition,
      renault_lead_reference_id: currentLead.renault_lead_reference_id,
      client_id: currentLead.client_id,
      note: note,
    };
  };

  const showError = (message) => {
    if (typeof Swal !== "undefined") {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: message,
        showCloseButton: true,
        confirmButtonText: "OK",
      });
    } else {
      alert(`❌ Erro: ${message}`);
    }
  };

  const showSuccess = (message) => {
    if (typeof Swal !== "undefined") {
      Swal.fire({
        icon: "success",
        title: "Sucesso",
        text: message,
        showCloseButton: true,
        timer: 2000,
        timerProgressBar: true,
        confirmButtonText: "OK",
      });
    } else {
      alert(`✅ ${message}`);
    }
  };

  return {
    init,
  };
})();

// Inicializar quando o DOM estiver pronto
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    ConvertToOpvModal.init();
  });
} else {
  ConvertToOpvModal.init();
}

export default ConvertToOpvModal;